import { CoverBackground } from 'components/CoverBackground'
import { useStoreActions, useStoreState } from 'hooks/useStore'
import { IoLogoWhatsapp } from 'react-icons/io'
import { MdLocalPhone } from 'react-icons/md'
import { Button } from 'reactstrap'
import styled from 'styled-components'
import { Lead } from 'views/property/lead'
import React, { ComponentType, useState } from 'react'
import { Share } from './share'

const Wrapper = styled.div`
  position: fixed;
  z-index: 1020;
  right: 0;
  bottom: 0;
  left: 0;
  background: white;
  box-shadow: 0 7px 18px 0 rgba(0, 5, 9, 0.33);
`

const Close = styled.button`
  position: absolute;
  height: 40px;
  width: 40px;
  background: #ffffff;
  box-shadow: 0 7px 18px 0 rgba(0, 5, 9, 0.33);
  border-radius: 40px;
  border: 0;
  top: -65px;
  left: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
`

const Body = styled.div`
  padding: 10px 16px;
`

const Content = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
`

const Image = styled(CoverBackground)`
  width: 56px;
  height: 56px;
  border-radius: 56px;
  margin-right: 16px;
`

const Info = styled.div`
  flex: 1;
`

const Name = styled.h6`
  margin: 0;
  font-size: 15px;
`

const Tag = styled.span`
  font-weight: 600;
  font-size: 10px;
  text-transform: uppercase;
`

const Anchor = styled.a`
  padding: 5px 14px;
`

const Cta = styled(Button)`
  padding-top: 14px;
  padding-bottom: 14px;
`
const generateTcw = () => {
  return `${Math.floor(Math.random() * 1000000000000)}`
}

const openWhatsappShare = (whatsapp: string, shareUrl: string) => {
  const cleanPhoneNumber = whatsapp.replace(/ /gi, '')
  const completePropertyUrl = `${shareUrl}?c=${generateTcw()}wa`
  const whatsappUrl = `https://api.whatsapp.com/send/?phone=521${cleanPhoneNumber}&text=Hola quisiera que se comuniquen por este inmueble que vi en Yucatán Premier ${encodeURI(completePropertyUrl)}`
  window.open(whatsappUrl, '__blank')
}

interface Props {
  agent: any
  name: string
  principalNotes: string
  uuid: string
  beforeOnShareClick: () => Promise<void>
  shareUrl: string
}

export const AgentMobile: ComponentType<Props> = ({ agent, name, principalNotes, uuid, beforeOnShareClick, shareUrl }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const invader = useStoreState((state) => state.ui.invader)
  const setInvader = useStoreActions((actions) => actions.ui.setInvader)

  const onMoreInformationClick = () => {
    beforeOnShareClick()
    setInvader('lead')
  }

  return (
    <>
      {invader === 'lead' && <Lead agent={agent} uuid={uuid} scrollLock />}
      <Wrapper>
        <Body>
          <Content>
            <Image url={agent.avatar?.thumbnailUrl} position="top center" />
            <Info>
              <Name>
                {agent.firstName} {agent.lastName}
              </Name>
              {agent.isCertified && <Tag className="text-certificate-orange">Asesor Certificado</Tag>}
            </Info>
            <Anchor
              onClick={() => (openWhatsappShare(agent.whatsapp, shareUrl))}
              className="text-malachite font-weight-500"
            >
              <IoLogoWhatsapp size={30} />
            </Anchor>
            <Anchor href={`tel:${agent.phone1}`} className="inversed-link font-weight-500">
              <MdLocalPhone size={30} />
            </Anchor>
            <Anchor className="font-weight-500">
              <Share iconSize={28} hideLabel subject={name} body={principalNotes} beforeOnShareClick={beforeOnShareClick} shareUrl={shareUrl} />
            </Anchor>
          </Content>
          <Cta color="primary" onClick={() => onMoreInformationClick()} block>
            Solicitar más información
          </Cta>
        </Body>
      </Wrapper>
    </>
  )
}
